<h3 class="keep-lines">{{ 'auth.auth-layout.reset-password.title' | translate }}</h3>
